function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class2, _class3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { bind, Component, emitEvent, register } from 'ovee.js';

var _class = (_dec = register('dropdown-list'), _dec2 = bind('dropdown-list:update-size'), _dec3 = bind('click', '.base-form__checkbox-label'), _dec(_class2 = (_class3 = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    _classCallCheck(this, _class3);

    return _super.apply(this, arguments);
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.inputs = this.$element.querySelectorAll('.base-form__checkbox');
      this.isMultiple = this.$element.classList.contains('multiple');
      this.trigger = this.$element.querySelector('[dropdown-trigger]');

      if (!this.trigger) {
        return;
      }

      this.isOpen = false;
      this.content = this.$element.dataset.dropdownList === 'filter' ? this.$element.querySelector('.dropdown-wrapper') : this.$element.querySelector('[dropdown-content]'); // this.wrapper = this.$element.querySelector('.dropdown-wrapper');

      this.trigger.setAttribute('aria-expanded', false);
      this.filterBar = this.$element.closest('[data-filter-bar]');
      this.siblings = [];

      if (this.filterBar) {
        this.siblings = this.filterBar.querySelectorAll('[dropdown-trigger]');
        var tempSiblings = [];
        this.siblings.forEach(function (sibling) {
          if (sibling.innerHTML !== _this.trigger.innerHTML) {
            tempSiblings.push(sibling);
          }
        });
        this.siblings = tempSiblings;
      }

      this.inputCount = this.$element.hasAttribute('data-count');
      this.countChecked();

      if (this.content) {
        this.updateContentSize();
      }

      this.bind();
    }
  }, {
    key: "toggleList",
    value: function toggleList() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }, {
    key: "open",
    value: function open() {
      this.$element.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', true);
      this.isOpen = true;
      this.closeSiblings();
    }
  }, {
    key: "close",
    value: function close() {
      this.$element.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', false);
      this.isOpen = false;
      this.countChecked();
    }
  }, {
    key: "closeSiblings",
    value: function closeSiblings() {
      if (this.siblings) {
        this.siblings.forEach(function (sibling) {
          emitEvent(sibling, 'close');
        });
      }
    }
  }, {
    key: "countChecked",
    value: function countChecked() {
      if (this.inputCount) {
        var checked = this.$element.querySelectorAll('input[type="checkbox"]:checked');
        this.trigger.setAttribute('data-checked-count', checked.length);
      }
    }
  }, {
    key: "updateContentSize",
    value: function updateContentSize() {
      this.$element.style.setProperty('--content-height', "".concat(Math.round(this.content.getBoundingClientRect().height), "px"));
    }
  }, {
    key: "bind",
    value: function bind() {
      this.$on('dropdowns-close', document, this.close);
      this.$on('click', this.trigger, this.toggleList);
      this.$on('close', this.trigger, this.close);
      this.$on('click', document, this.handleOutsideClick);

      if (this.content) {
        this.$on('resize-x', window, this.updateContentSize);
      }

      if (this.inputCount) {
        this.$on('modal-close', window, this.countChecked);
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(event) {
      if (!this.$element.contains(event.target) && this.isOpen) {
        this.close();
      }
    }
  }, {
    key: "onLabelClick",
    value: function onLabelClick(event) {
      if (!this.isMultiple) {
        this.inputs.forEach(function (input) {
          if (!event.target.contains(input)) {
            input.checked = false;
          }
        });
        this.close();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$off('click', this.trigger, this.toggleList);
      this.$off('close', this.trigger, this.close);
      this.$off('click', document, this.handleOutsideClick);
      this.$off('dropdowns-close', document, this.close);

      if (this.content) {
        this.$off('resize-x', window, this.updateContentSize);
      }

      if (this.inputCount) {
        this.$off('modal-close', window, this.countChecked);
      }
    }
  }]);

  return _class3;
}(Component), (_applyDecoratedDescriptor(_class3.prototype, "updateContentSize", [_dec2], Object.getOwnPropertyDescriptor(_class3.prototype, "updateContentSize"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "onLabelClick", [_dec3], Object.getOwnPropertyDescriptor(_class3.prototype, "onLabelClick"), _class3.prototype)), _class3)) || _class2);

export { _class as default };